import React, { useContext } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Tooltip, Typography } from '@mui/material';
import { nameFormatted } from '../../utils/Hooks/nameFormatted';

function UserDetails() {

  const { cuitNumber, consultoriosContrato } = useContext(AgendaContext);
  const theme = useTheme();



  return (
    <Box
      sx={{
        display: 'flex',
        border: `2px solid ${theme.palette.backgroundSecondary.main}`,
        borderRadius: '1rem',
        width: '656px',
        height: '100px',
        padding: '1.5rem',
        justifyContent: 'space-between',
        gap: '1em'
      }}>
      <Box sx={{ width: '60%' }}>
        <Typography variant="h3">
          Te damos la bienvenida a la solicitud de conexión de agendas
        </Typography>
      </Box>

      <Box sx={{ flex: 'flex', width: '35%' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
          <Typography variant="bodyS" style={{ whiteSpace: 'nowrap' }}>
            Razón social:{' '}
            <Tooltip title={consultoriosContrato.nombre && nameFormatted(consultoriosContrato.nombre)} placement="top">
              <Typography
                component="span"
                style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
                {' '}{consultoriosContrato.nombre && nameFormatted(consultoriosContrato.nombre)}
              </Typography>
            </Tooltip>
          </Typography>
          <Typography variant="bodyS" style={{ whiteSpace: 'nowrap' }}>
            CUIT:
            <Typography
              component="span"
              style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
              {' '}{cuitNumber}
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default UserDetails;
